export const INTERACTIVE_TEMPLATES_LIST = {
  INTERACTIVE_TEMPLATES_TITLE: { key: 'INTERACTIVE_TEMPLATES_TITLE', value: 'Interactive Documents' },
  INTERACTIVE_TEMPLATES_DESCRIPTION: {
    key: 'INTERACTIVE_TEMPLATES_DESCRIPTION',
    value:
      'Review and finalize the interactive documents',
  },
  LOADING_MORE: {
    key: 'LOADING_MORE',
    value: 'Loading more...',
  },
  GOT_ALL_TEMPLATES_LIST: {
    key: 'GOT_ALL_TEMPLATES_LIST',
    value: 'You have got all results',
  },
  DELETE_TEMPLATE_DROPDOWN_OPTION: {
    key: 'DELETE_TEMPLATE',
    value: 'Delete',
  },
  EDIT_TEMPLATE_DROPDOWN_OPTION: {
    key: 'EDIT_TEMPLATE',
    value: 'Edit',
  },
  EMPTY_TEMPLATES_LIST: { key: 'EMPTY_TEMPLATES_LIST', value: 'Templates list is empty.' },
  ATTACHED_EMAIL: { key: 'ATTACHED_EMAIL', value: 'Attached to Email'}
};

export const ADVANCED_FILTER = {
  ADVANCED_FILTER_TITLE: {
    key: 'FILTER_TITLE',
    value: 'Advanced Search',
  },
  FILTER_CLEAR_ALL: {
    key: 'FILTER_CLEAR_ALL',
    value: 'Clear all filter',
  },
  FILTER_SEARCH_BUTTON: {
    key: 'FILTER_SEARCH_BUTTON',
    value: 'Search',
  },
  FILTER_BY_NAME_LABEL: {
    key: 'FILTER_BY_NAME_LABEL',
    value: 'Search by name',
  },
  FILTER_BY_NAME_PLACEHOLDER: {
    key: 'FILTER_BY_NAME_PLACEHOLDER',
    value: 'Search by name',
  },
  FILTER_BY_CATEGORY_LABEL: {
    key: 'FILTER_BY_CATEGORY_LABEL',
    value: 'Categories',
  },
  FILTER_BY_STATUS_LABEL: {
    key: 'FILTER_BY_STATUS_LABEL',
    value: 'Status',
  },
  FILTER_WAITING_FOR_APPROVAL_LABEL: {
    key: 'FILTER_WAITING_FOR_APPROVAL_LABEL',
    value: 'waiting for approval',
  },
  FILTER_BY_TAGS_LABEL: {
    key: 'FILTER_BY_TAGS_LABEL',
    value: 'search by tags',
  },
  FILTER_BY_TAGS_PLACEHOLDER: {
    key: 'FILTER_BY_TAGS_PLACEHOLDER',
    value: 'search by tags',
  },
  FILTER_SHOW_ALL_CATEGORIES_ACTION: {
    key: 'FILTER_SHOW_ALL_CATEGORIES_ACTION',
    value: 'more categories',
  },
  EMPTY_CATEGORIES_LIST: {
    key: 'EMPTY_CATEGORIES_LIST',
    value: 'Categories list is empty',
  },
  LANGUAGE_SEARCH_FILTER_LABEL: {
    key: 'LANGUAGE_SEARCH_FILTER_LABEL',
    value: 'Search By Language',
  },
  ALL_OPTION: {
    key: 'ALL_OPTION',
    value: 'All',
  },
  FILTER_BY_CHANNEL_LABEL: {
    key: 'FILTER_BY_CHANNEL_LABEL',
    value: 'Channel',
  },
  CHANNEL_FILTER_PRINT_LABEL: {
    key: 'CHANNEL_FILTER_PRINT_LABEL',
    value: 'Print',
  },
  CHANNEL_FILTER_EMAIL_LABEL: {
    key: 'CHANNEL_FILTER_EMAIL_LABEL',
    value: 'Email',
  }
};

export const  REUSABLE_SECTION_DESIGN  = {
  REUSABLE_SECTION_BUTTON: { key: 'REUSABLE_SECTION_BUTTON', value: 'Reusable sections' },
  ADD_NEW_REUSABLE_SECTION_TOOLTIP: {
    key: 'ADD_NEW_REUSABLE_SECTION_TOOLTIP',
    value: 'Add new Reusable section',
  },
}
